import HeatmapModule from "./HeatmapModule";
import HeatmapModuleSaga from "./redux/heatmapSaga";
import HeatmapModuleReducer from "./redux/heatmapReducer";

export default {
  Component: HeatmapModule,
  moduleName: "retentionHeatmap",
  saga: HeatmapModuleSaga(),
  reducer: HeatmapModuleReducer
};
